<template>
  <LazyLoad>
    <DownloadsDocumentsDocumentCenterProductList
      :sorted-criteria="isDiscontinued ? [DISCONTINUATION_LETTER] : []"
    />
  </LazyLoad>
</template>
<script setup lang="ts">
import { useProductDetailPageStore } from '~/stores/productDetailPageStore/productDetailPageStore';
import { useDownloadStore } from '~/stores/downloadStore/downloadStore';
import { DISCONTINUATION_LETTER } from '~/components/downloads/documents/constants';
import LazyLoad from '~/components/lib/LazyLoad.vue';

const store = useProductDetailPageStore();
const downloadStore = useDownloadStore();

const isDiscontinued = computed(
  () => store.decoratedProduct?.isDiscontinued ?? false
);

// reset downloader center as the store is used in multiple places (pdp or
// standalone).
// We can not reset the store (via $reset) as in the standalone version
// the route for the modal triggers a unmount and mount of all components.
// @see https://gcp.baslerweb.com/jira/browse/DBP-1237

onBeforeUnmount(() => {
  downloadStore.$reset();
});
onMounted(() => {
  downloadStore.$patch({
    context: 'pdp',
    downloads: null,
    staticFilters: { skus: [store.decoratedProduct?.sku!] },
    documentationLink: {
      url: store.decoratedProduct?.productDocumentationLink ?? '',
      slug: store.decoratedProduct?.productDocumentationLinkSlug ?? ''
    }
  });
});
</script>
